import HeaderFooterLayout from 'layouts/HeaderFooterLayoutNew';
import React from 'react';
import styles from './styles.module.css';
import { useLocation } from 'react-router-dom';
const AdvertisementIframePage = () => {
  const location = useLocation();
  const { mobileFormURL, url } = location.state;
  return (
    <div className={styles.body}>
      <HeaderFooterLayout>
        <iframe
          id="mvpTrainingIframe"
          src={url || mobileFormURL}
          width="100%"
          height={document.documentElement.clientHeight - 50}
          title="iframe"
        />
      </HeaderFooterLayout>
    </div>
  );
};

export default AdvertisementIframePage;
